import { proxy } from 'valtio'

export const jerry597_store = proxy({ strategy: 'long' as 'long' | 'short' | 'default' })
